import { ModelTypes } from '@/typings/types/types';
import { ClipboardState } from '@/store/modules/clipboard/state';
import { MutationTree } from 'vuex';

export type Mutations<S = ClipboardState> = {
  addModelToClipboard(state: S, model: ModelTypes): void;
  addDataToClipboard(state: S, data: string): void;
  removeElementFromClipboard(state: S): void;
};

export const mutations: MutationTree<ClipboardState> & Mutations = {
  addModelToClipboard: (state, model) => {
    state.elementInClipboard = model;
  },
  addDataToClipboard: (state, data) => {
    state.dataInClipboard = data;
  },
  removeElementFromClipboard: (state) => {
    state.dataInClipboard = null;
    state.elementInClipboard = null;
  }
};
